import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EventStatusFilter } from '../../utils/event-status'

interface IEventSearchState {
  token: string | null
  pageSize: number
  currentPage: number
  selectedDates: Date[]
  selectedStatuses: EventStatusFilter[]
}

const initialState: IEventSearchState = {
  token: null,
  pageSize: 10,
  currentPage: 1,
  selectedDates: [],
  selectedStatuses: []
}

const eventSearch = createSlice({
  name: 'eventSearch',
  initialState,
  reducers: {
    setSearchToken: (state, action: PayloadAction<IEventSearchState>) => {
      state.token = action.payload.token
      state.pageSize = action.payload.pageSize
      state.currentPage = action.payload.currentPage
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setSelectedDates: (state, action: PayloadAction<Date[]>) => {
      state.selectedDates = action.payload
      state.currentPage = 1
    },
    setSelectedStatuses: (state, action: PayloadAction<EventStatusFilter[]>) => {
      state.selectedStatuses = action.payload
      state.currentPage = 1
    },
    clearSearchToken: () => {
      return {
        ...initialState
      }
    }
  }
})

export const { setSearchToken, clearSearchToken, setCurrentPage, setSelectedDates, setSelectedStatuses } = eventSearch.actions
export const searchEventReducer = eventSearch.reducer
